package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.data.models.domain.Status
import com.klantenstop.web.styles.staticAcceptColor
import com.klantenstop.web.styles.staticDeclineColor
import com.klantenstop.web.styles.staticPauseColor
import com.klantenstop.web.styles.staticUnknownColor
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

fun Status.Type.toColor() = when (this) {
    Status.Type.Accept -> staticAcceptColor
    Status.Type.Pause -> staticPauseColor
    Status.Type.Decline -> staticDeclineColor
    Status.Type.Unknown -> staticUnknownColor
}

@Composable
fun KsCategoryChip(
    category: Category,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .backgroundColor(MaterialColorVars.SecondaryContainer.value())
            .borderRadius(16.px)
            .padding(leftRight = 12.px, topBottom = 6.px),
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            modifier = Modifier
                .fontSize(12.px)
                .lineHeight(14.px)
                .fontWeight(FontWeight.Medium)
                .color(MaterialColorVars.OnSecondaryContainer.value()),
            text = category.name
        )
    }
}

@Composable
fun KsCategoryRow(
    categories: List<Category>,
    modifier: Modifier = Modifier,
    maxVisible: Int = 3
) {
    if (categories.isEmpty()) return

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Show first N categories
        categories.take(maxVisible).forEach { category ->
            KsCategoryChip(category = category)
        }

        // Show "+X more" if there are additional categories
        val remaining = categories.size - maxVisible
        if (remaining > 0) {
            SpanText(
                modifier = Modifier
                    .fontSize(12.px)
                    .lineHeight(14.px)
                    .fontWeight(FontWeight.Medium)
                    .color(MaterialColorVars.Outline.value()),
                text = "+$remaining meer"
            )
        }
    }
}

